import { Component } from "react";

// Without this, an uncaught render error unmounts the whole tree and leaves a
// blank page with nothing to click — this at least gives the user a way back
// in, and logs the real error instead of it disappearing silently.
export default class ErrorBoundary extends Component {
  state = { error: null };

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    console.error("Unhandled render error", error, info?.componentStack);
  }

  render() {
    if (!this.state.error) return this.props.children;
    return (
      <div style={{ display: "grid", placeItems: "center", minHeight: "100vh", padding: 24, textAlign: "center", font: "400 14px/20px 'Poppins', sans-serif" }}>
        <div>
          <h2 style={{ margin: "0 0 8px" }}>Something went wrong</h2>
          <p style={{ margin: "0 0 16px", color: "#666" }}>{this.state.error.message || "The page hit an unexpected error."}</p>
          <button
            type="button"
            onClick={() => window.location.reload()}
            style={{ padding: "10px 20px", borderRadius: 8, border: "none", background: "#0BBDDD", color: "#fff", font: "600 14px/20px 'Poppins', sans-serif" }}
          >
            Reload
          </button>
        </div>
      </div>
    );
  }
}
